export default __webpack_public_path__ + "8def6104a1df9d65a664abe0d592fa22.svg";